<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div>
      <b-card>
        <b-card-title>
          <h5 class="card-title">Consultar</h5>
        </b-card-title>

        <div class="row">
          <div class="flex-responsive justify-content-end align-self-center">
            <calendario
              label="Ano"
              inputText="ANO"
              tipoData="ano"
              :validado="validadoAno"
              :disabledData="(date) => date >= new Date()"
              :filtro="dados.ano"
              v-on:emitindoAno="atribuiAno"
              class="me-2"
            />
            <b-form-group
              label="Contrato Serviço"
              invalid-feedback="campo obrigatório"
              class="me-2 w-30"
            >
              <multiselect
                v-model="dados.contrato"
                placeholder="Selecione"
                :show-labels="false"
                :options="objetoContrato"
                :custom-label="
                  ({ contrato, sq_contrato }) =>
                    `${contrato} - [${sq_contrato}]`
                "
                :allow-empty="false"
              />
            </b-form-group>
            <div class="me-2 align-self-center mt-1">
              <b-button class="" variant="primary" @click="geraGrafico()">
                <i class="mdi mdi-chart-bar font-size-16 align-middle me-2"></i>
                Gera Gráficos
              </b-button>
            </div>
            <router-link
              class="align-self-center mt-1"
              to="/tomadora/compliance/documentos_faturados"
            >
              <b-button variant="primary">
                <i
                  class="mdi mdi-clipboard-list-outline font-size-16 align-middle me-2"
                ></i>
                Visualizar Relatório
              </b-button>
            </router-link>
          </div>
        </div>
      </b-card>
    </div>

    <div class="row mt-3 text-center" v-if="showGraficos">
      <!-- NOTA -->
      <div class="col-xl-6 col-12">
        <b-card>
          <b-card-title>
            <h5 class="card-title">{{ graficosView[0].nome }}</h5>
          </b-card-title>

          <div class="row text-center">
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ formataParaReais(graficosView[0].debito) }}
              </h5>
              <p class="text-muted">Bruto</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ formataParaReais(graficosView[0].credito) }}
              </h5>
              <p class="text-muted">Tributos</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ formataParaReais(graficosView[0].liquido) }}
              </h5>
              <p class="text-muted">Liquido</p>
            </div>
          </div>

          <BarChart
            :height="300"
            :labelsChart="Meses"
            :data="graficosView[0].dados"
            :datasetsLabel="graficosView[0].nome"
            color="#E6BE86"
          />
        </b-card>
      </div>
      <!-- NDC -->
      <div class="col-xl-6 col-12">
        <b-card>
          <b-card-title>
            <h5 class="card-title">{{ graficoNdc.nome }}</h5>
          </b-card-title>

          <div class="row text-center">
            <div class="col-sm-4">
              <h5 class="mb-0">{{ formataParaReais(graficoNdc.debito) }}</h5>
              <p class="text-muted">Debito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">{{ formataParaReais(graficoNdc.credito) }}</h5>
              <p class="text-muted">Credito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">{{ formataParaReais(graficoNdc.liquido) }}</h5>
              <p class="text-muted">Liquido</p>
            </div>
          </div>

          <stackedBar
            :height="300"
            :labelsChart="Meses"
            :data="graficoNdc.dados"
          />
        </b-card>
      </div>
      <!-- RDV -->
      <div class="col-xl-6 col-12">
        <b-card>
          <b-card-title>
            <h5 class="card-title">{{ graficosView[1].nome }}</h5>
          </b-card-title>

          <div class="row text-center">
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[1].debito) }}
              </h5>
              <p class="text-muted">Debito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[1].credito) }}
              </h5>
              <p class="text-muted">Credito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[1].liquido) }}
              </h5>
              <p class="text-muted">Liquido</p>
            </div>
          </div>

          <BarChart
            :height="300"
            :labelsChart="Meses"
            :data="graficosView[1].dados"
            :datasetsLabel="graficosView[1].nome"
            color="#34C38F"
          />
        </b-card>
      </div>
      <!-- FROTA -->
      <div class="col-xl-6 col-12">
        <b-card>
          <b-card-title>
            <h5 class="card-title">{{ graficosView[2].nome }}</h5>
          </b-card-title>

          <div class="row text-center">
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[2].debito) }}
              </h5>
              <p class="text-muted">Debito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[2].credito) }}
              </h5>
              <p class="text-muted">Credito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[2].liquido) }}
              </h5>
              <p class="text-muted">Liquido</p>
            </div>
          </div>

          <BarChart
            :height="300"
            :labelsChart="Meses"
            :data="graficosView[2].dados"
            :datasetsLabel="graficosView[2].nome"
            color="#556EE6"
          />
        </b-card>
      </div>
      <!-- DIVERSOS -->
      <div class="col-xl-6 col-12">
        <b-card>
          <b-card-title>
            <h5 class="card-title">{{ graficosView[3].nome }}</h5>
          </b-card-title>

          <div class="row text-center">
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[3].debito) }}
              </h5>
              <p class="text-muted">Debito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[3].credito) }}
              </h5>
              <p class="text-muted">Credito</p>
            </div>
            <div class="col-sm-4">
              <h5 class="mb-0">
                {{ $tools.converteReal(graficosView[3].liquido) }}
              </h5>
              <p class="text-muted">Liquido</p>
            </div>
          </div>

          <BarChart
            :height="300"
            :labelsChart="Meses"
            :data="graficosView[3].dados"
            :datasetsLabel="graficosView[3].nome"
            color="#FLB44C"
          />
        </b-card>
      </div>
    </div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import BarChart from "@/components/graficos/BarChart";
import stackedBar from "@/components/graficos/stackedBar";
import calendario from "@/components/formulario/data-input";
import Multiselect from "vue-multiselect";

export default {
  components: {
    PageHeader,
    BarChart,
    stackedBar,
    calendario,
    Multiselect,
  },
  data() {
    return {
      grafico: [],
      title: "Compliance",
      validadoAno: null,
      validadoMes: null,
      objetoContrato: [],
      showGraficos: false,
      loading: false,
      items: [
        {
          text: "Compliance",
        },
      ],
      dados: {
        ano: null,
        contrato: null,
      },
      Meses: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      graficosView: [
        {
          nome: "NFS-e",
          dados: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          debito: 0,
          credito: 0,
          liquido: 0,
        },
        {
          nome: "NDC - RDV",
          dados: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          debito: 0,
          credito: 0,
          liquido: 0,
        },
        {
          nome: "NDC - FROTA",
          dados: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          debito: 0,
          credito: 0,
          liquido: 0,
        },
        {
          nome: "NDC - Diversos",
          dados: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          debito: 0,
          credito: 0,
          liquido: 0,
        },
      ],
      graficoNdc: {
        nome: "NDC (Geral)",
        dados: [],
        debito: 0,
        credito: 0,
        liquido: 0,
      },
    };
  },
  created() {
    this.$http
      .get("api/compliance")
      .then((response) => {
        this.objetoContrato = response.data.contratos;
        this.dados.contrato = response.data.contratos[0];
      })
      .catch((err) => {
        console.log(err);
      });
    var ano = new Date().getFullYear();
    this.dados.ano = ano.toString();
  },
  methods: {
    montaGraficos() {
      for (let index = 0; index < this.graficosView.length; index++) {
        this.graficosView[index].dados = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.graficosView[index].debito = 0;
        this.graficosView[index].credito = 0;
        this.graficosView[index].liquido = 0;
      }
      this.grafico.forEach((value) => {
        this.graficosView[value.tp_modelo_documento].dados[
          value.mes_referencia.substr(0, 2) - 1
        ] = value.vl_liquido;
        this.graficosView[value.tp_modelo_documento].debito += parseFloat(
          value.vl_debito
        );
        this.graficosView[value.tp_modelo_documento].credito += parseFloat(
          value.vl_credito
        );
        this.graficosView[value.tp_modelo_documento].liquido += parseFloat(
          value.vl_liquido
        );
        this.graficosView[value.tp_modelo_documento].nome =
          value.modelo_documento;
      });
      this.graficoNdc.dados = [
        {
          label: this.graficosView[1].nome,
          data: this.graficosView[1].dados,
          backgroundColor: "#34C38F",
          stack: "Stack 0",
        },
        {
          label: this.graficosView[2].nome,
          data: this.graficosView[2].dados,
          backgroundColor: "#556EE6",
          stack: "Stack 0",
        },
        {
          label: this.graficosView[3].nome,
          data: this.graficosView[3].dados,
          backgroundColor: "#FLB44C",
          stack: "Stack 0",
        },
      ];
      this.graficoNdc.debito =
        this.graficosView[1].debito +
        this.graficosView[2].debito +
        this.graficosView[3].debito;
      this.graficoNdc.credito =
        this.graficosView[1].credito +
        this.graficosView[2].credito +
        this.graficosView[3].credito;
      this.graficoNdc.liquido =
        this.graficosView[1].liquido +
        this.graficosView[2].liquido +
        this.graficosView[3].liquido;
      this.loading = false;
      this.showGraficos = true;
    },
    atribuiAno(ano) {
      this.dados.ano = ano;
    },
    geraCores() {
      return (
        "#" +
        parseInt(Math.random() * 0xffffff)
          .toString(16)
          .padStart(6, "0")
      );
    },
    formataParaReais(value) {
      var stringParaFloat = parseFloat(value);
      var valorFormatado = stringParaFloat.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
      return valorFormatado;
    },
    geraGrafico() {
      this.grafico = [];
      this.loading = true;
      this.showGraficos = false;
      var objetoDeEnvio =
        "api/compliance/grafico/" +
        this.dados.ano +
        "/" +
        this.dados.contrato.sq_contrato;
      this.$http.get(objetoDeEnvio).then((response) => {
        this.grafico = response.data;
        this.montaGraficos();
      });
    },
  },
};
</script>
<style>
</style>

